<template>
    <form>
        <div class="mobile-header">
            <div class="top-mobile-ribbon d-lg-none mb-0">
                <div class="navigation-wrp">
                    <div class=" header-search-cont ">
                        <div class="input-group mobile-header-search">
                            <a class="back-link" href="#/">
                                <span class="icon icon-arrow_left"></span>
                            </a>
                            <input type="text" class="form-control search-input"
                                   id="txtSearchTerms" name="txtSearchTerms" placeholder="Search for"
                                   v-model="searchModel.pagingParameters.filtrationCriteria.searchTerms" @keyup.enter="onFilter()">
                            <button class="btn btn-primary form-control search-btn filter-search-btn" type="button" @click="onFilter()">
                                <i class="icon icon-search_glass_1-rtl"></i>
                            </button>
                            <a class="search-link header-search-btn">
                                <i class="icon icon-search_glass_1-rtl"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group sort-filter">
            <div class="dropdown">
                <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                    <span class="icon icon-sort"></span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="top-start" style="position: absolute; transform: translate3d(0px, -2px, 0px); top: 0px; left: -5rem; will-change: transform;">
                    <a class="dropdown-item" :class="{active: searchModel.pagingParameters.sortingCriteria.sortCriteria === sortValue.id}" @click="onSort(sortValue.id)" v-for="sortValue in searchModel.searchLookups.sortLookups" :key="sortValue.id">{{sortValue.title}}</a>
                </div>
            </div>
        </div>
        <div class="mobile-filter">
            <div class="filter-cont">
                <div class="filter-close-clear">
                    <a alt="close" class="filter-close">
                        <span class="icon icon-close1"></span>
                    </a>
                    <button type="button" @click="clearAllControls()" class="filter-clear">
                        {{$t("ClearFilters")}}
                    </button>
                </div>
                <button class="login-btn btn btn-primary filter-apply singleLine fx-center" :disabled="searchModel.isFormDisabled == true" type="button" @click="onFilter()">{{$t("Apply")}}</button>
            </div>
        </div>
        <div class="tag-mobile row">
            <div class="form-group col-12 clear-content">

                <div v-for="tag in searchModel.tags" :key="tag.id" class="tags">
                    <div target="_blank" title="tag" class="badge badge-pill badge-primary-gray">
                        <span class="lineTrim-1">{{$t(tag.type)}}:{{tag.title}}</span>
                        <button class="remove-tag" type="button" @click="removeTag(tag)">
                            <span class="icon icon-close1"></span>
                        </button>
                    </div>
                </div>


            </div>

        </div>
        <div class="desktop-filters row">

            <div class="form-group col-md-4 col-sm-5">
                <label class="noLabel" :placeholder='$t("SearchFor")' for="txtSearchTerms">{{$t("SearchFor")}}</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control"
                           id="txtSearchTerms" name="txtSearchTerms"
                           v-model="searchModel.pagingParameters.filtrationCriteria.searchTerms" @keyup.enter="onFilter()">

                    <div class="input-group-prepend">
                        <button class="btn btn-primary form-control" type="button" @click="onFilter()">
                            <i class="icon icon-search_glass_1-rtl"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-2 col-sm-4">
                <label class="noLabel" for="dropdownMenuButton">{{$t("SortBy")}}</label>
                <div class="dropdown">
                    <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                        {{$t("SortBy")}}
                        <span class="icon icon-sort"></span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="top-start" style="position: absolute; transform: translate3d(0px, -2px, 0px); top: 0px; left: 0px; will-change: transform;">
                        <a class="dropdown-item" :class="{active: searchModel.pagingParameters.sortingCriteria.sortCriteria === sortValue.id}" @click="onSort(sortValue.id)" v-for="sortValue in searchModel.searchLookups.sortLookups" :key="sortValue.id">{{sortValue.title}}</a>
                    </div>
                </div>

            </div>
            <div class="form-group col-12 clear-content">
                <div v-for="tag in searchModel.tags" :key="tag.id" class="tags">
                    <div target="_blank" title="tag" class="badge badge-pill badge-primary-gray">
                        <span class="lineTrim-1">{{$t(tag.type)}}:{{tag.title}}</span>
                        <button class="remove-tag" type="button" @click="removeTag(tag)">
                            <span class="icon icon-close1"></span>
                        </button>
                    </div>
                </div>

                <button v-if="searchModel.tags.length > 0" class="btn btn-link clear-btn" type="button" @click="clearAllControls()">{{$t("ClearAll")}}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import DocumentsModel from "./DocumentsModel";
    import { PrimeVueLocale } from '../../locales/PrimeVueLocale.js'
    //import $ from "jquery";

    export default {
        name: "DocumentsMainFilters",
        data: function () {
            debugger;
            return {
                searchModel: window.searchModel ? window.searchModel : (window.searchModel = new DocumentsModel(this.$i18n, this.$http, window.pagingParameters, window.searchLookups, this.$router))

            };
        },
        created() {
            debugger;
            this.changePrimeVuelocle(window.getLang());
            this.intializeControls();
        },
        updated: function () {

        },
        methods: {

            changePrimeVuelocle(lang) {
                this.$primevue.config.locale = PrimeVueLocale[lang];
            },
            intializeControls: function () {
                return this.searchModel.intializeControls();
            },
            removeTag: function (tag) {
                debugger;
                return this.searchModel.removeTag(tag);
            },
            clearAllControls: function () {
                this.searchModel.clearAllControls();
                this.searchModel.onFilter();
            },
            onFilter: function () {
                return this.searchModel.onFilter();
            },
            onSort: function (sortId) {
                return this.searchModel.onSort(sortId);
            },
            onFilterType: function (typeId) {
                return this.searchModel.onFilterType(typeId);
            }

        },
        components: {

        },
        computed: {

        }
    }
</script>
